module.exports = __webpack_public_path__ + "static/media/icon-check-alt.8f23077f.svg";